import React from 'react'

import { PhnxButton } from '../../01-atoms/Button/Button'
import styles from './Sectionheader.module.css'

type Tag = {
  label: string
  url: string
}

export type SectionheaderProps = {
  //  variant?: 'primary' | 'secondary' | 'tertiary'
  title: string
  subtitle?: string
  tags?: Tag[]
  link?: { label: string; url: string }
  asset?: React.ReactNode
}

export const PhnxSectionheader: React.FC<SectionheaderProps> = (props) => {
  const { title, subtitle, tags, link, asset } = props

  return (
    <div className={`${styles.sectionheader}`}>
      <div className={styles.assetContainer}>{asset}</div>
      <div className={styles.contentContainer}>
        {link && typeof link.url === 'string' && link.url.trim() !== '' && (
          <PhnxButton
            type="link"
            href={link.url}
            label={link.label}
            size="default"
            variant="senary"
            icon="fx-icon-arrow-up-lg"
            iconPosition="left"
          />
        )}
        <h2 className={styles.headerTitle}>
          {title}
          {typeof subtitle === 'string' && subtitle.trim() !== '' && (
            <div className={`h3 ${styles.headerSubtitle}`}>{subtitle}</div>
          )}
        </h2>

        {Array.isArray(tags) && tags.length > 0 && (
          <div className={styles.tagsContainer}>
            {tags.map((item) => (
              <PhnxButton
                key={item.label}
                type="link"
                href={item.url}
                label={item.label}
                size="small"
                variant="quinary"
              />
            ))}
          </div>
        )}
      </div>
    </div>
  )
}
